import React from 'react'
import { Navigate } from 'react-router-dom'

import { Loading } from 'components'
import { useAuth } from 'modules/auth'

export const HomePage = () => {
  const { auth, loading } = useAuth()

  if (loading) {
    return <Loading />
  }

  if (auth) {
    if (auth.authorities.includes('ROLE_ADMIN')) {
      return <Navigate to='/admin' />
    } else if (auth.authorities.includes('ROLE_USER')) {
      return <Navigate to='/acesso' />
    } else if (auth.authorities.includes('ROLE_GUEST')) {
      return <Navigate to='/guest' />
    }
  }

  return <Navigate to='/login' />
}

export default HomePage
